'use client';

import { type HTMLAttributes } from 'react';
import { Heading } from '@paypoteam/ui-components/Heading';

export interface H1Props extends HTMLAttributes<HTMLHeadingElement> {
    size?: '6xl' | '5xl' | '4xl' | '3xl' | '2xl' | 'xl';
}

export default function H1({ children, size = '6xl', ...props }: H1Props) {
    return (
        <Heading
            type="h1"
            size={size}
            {...props}
        >
            {children}
        </Heading>
    );
}
